<template>
  <section id="help">
    <v-container class="mb-10">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <h1 class="text-center pt-6 font-weight-bold display-2">
            Need Help?
          </h1>
          <h3 class="font-weight-light mt-5 mb-3 text-center">
            If you have any question, please do not hesitate to talk to us.
          </h3>
        </v-col>
      </v-row>
      <v-row align="center" justify="space-around">
        <v-col cols="12" xs="1" sm="1" md="1" lg="1" xl="1"></v-col>
        <v-col cols="12" xs="10" sm="10" md="10" lg="10" xl="10">
          <v-row justify="space-around">
            <v-col>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold text-h5"
                    >Registrar unit</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >from 08:00 a.m. to 05:00 p.m.</v-list-item-subtitle
                  >
                  <!-- <v-divider class="mt-3 mb-3"></v-divider> -->
                  <v-list-item-subtitle class="mt-2">
                    Line official : <strong>@MYMUIC</strong>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      class="mr-2"
                      href="https://lin.ee/rMSY9VY"
                    >
                      <img
                        class="ml-3"
                        src="https://scdn.line-apps.com/n/line_add_friends/btn/en.png"
                        alt="add"
                        height="30"
                        border="0"
                      />
                    </a>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="mt-3">
                    <p class="mt-0 mb-0">
                      Emai :
                      <a class="ml-2" href="mailto:icru@mahidol.ac.th">
                        <u class="font-weight-bold">icru@mahidol.ac.th</u>
                      </a>
                    </p>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="mt-3">
                    Office phone number :
                    <p class="mt-1 mb-0">
                      <strong>(+66) 02-700-5000 Ext. 4331-4334</strong>
                    </p>
                    <p class="mt-1 mb-0">
                      <strong>4336, 4342, 4330, 4325</strong>
                    </p>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold text-h5"
                    >Division contact</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >from 08:00 a.m. to 05:00 p.m.</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <!-- <v-divider class="mt-3 mb-3"></v-divider> -->
              <div class="text-center">
                <v-dialog v-model="dialog" width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="blue darken-3" dark v-bind="attrs" v-on="on">
                      Contact lists
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      LIST
                    </v-card-title>
                    <v-card-text>
                      <v-list-item
                        class="mt-2"
                        v-for="(data, index) in dataContact"
                        :key="'data' + index"
                        three-line
                      >
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">{{
                            data.name
                          }}</v-list-item-title>
                          <v-list-item-subtitle v-if="data.line5 !== ''">
                            {{ data.line5 }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="mb-2" v-if="data.line2 !== ''">
                            {{ data.line2 }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <a :href="`mailto:${data.mail}`">
                              <u class="font-weight-bold">{{ data.mail }}</u>
                            </a>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data.line4 !== ''">
                            <a :href="`mailto:${data.line4}`">
                              <u class="font-weight-bold">{{ data.line4 }}</u>
                            </a>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data.line3 !== ''">
                            {{ data.line3 }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <div class="mt-2 mb-2 text-h6 font-weight-bold">
                        MUIC Secretary Unit
                      </div>
                      <v-list-item
                        v-for="(data2, index) in dataContact2"
                        :key="'data2' + index"
                        three-line
                      >
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">{{
                            data2.name
                          }}</v-list-item-title>
                          <v-list-item-subtitle v-if="data2.tel !== ''">
                            {{ data2.tel }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data2.mail !== ''">
                            {{ data2.mail }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data2.mail1 !== ''">
                            {{ data2.mail1 }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data2.mail2 !== ''">
                            {{ data2.mail2 }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data2.line1 !== ''">
                            {{ data2.line1 }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data2.line2 !== ''">
                            {{ data2.line2 }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data2.line3 !== ''">
                            {{ data2.line3 }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="data2.line4 !== ''">
                            {{ data2.line4 }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialog = false">
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-col>
            <v-col>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold text-h5"
                    >SKY+ Support</v-list-item-title
                  >
                  <!-- <v-divider class="mt-3 mb-3"></v-divider> -->
                  <v-list-item-subtitle class="mt-2">
                    MY MUIC :
                    <a
                      class="ml-2"
                      target="_blank"
                      href="https://newmy.muic.io/service/form"
                    >
                      <u class="font-weight-bold"
                        >https://newmy.muic.io/service/form</u
                      >
                    </a>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="mt-2">
                    Academic Schedule :
                    <a class="ml-2" target="_blank" href="https://os.muic.io/">
                      <u class="font-weight-bold">https://os.muic.io/</u>
                    </a>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="mt-2">
                    Email :
                    <a
                      class="ml-2"
                      target="_blank"
                      href="mailto:icsky@mahidol.ac.th"
                    >
                      <u class="font-weight-bold">icsky@mahidol.ac.th</u>
                    </a>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="mt-2">
                    Hotline : (+66) 02-700-5055
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" xs="1" sm="1" md="1" lg="1" xl="1"></v-col>
      </v-row>
    </v-container>
    <v-container>
      <div class="mt-5 svg-border-waves text-white">
        <v-img src="~@/assets/img/borderWavesBlue.svg" />
      </div>
      <v-snackbar
        v-model="snackbar.enabled"
        timeout="3000"
        right="right"
        top="top"
        :color="snackbar.color"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text="text" v-bind="attrs" @click="snackbar.enabled = false">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    snackbar: {
      enabled: false,
      text: "",
      color: "",
    },
    dataContact: [
      {
        name: "The Admission Unit",
        mail: "icdad@mahidol.ac.th",
        line2: "Tel. 0-2700-5000 ext. 4334-4337",
        line3: "LINE: @muicfriend",
        line4: "",
        line5: "",
      },
      {
        name: "The Registrar Unit",
        mail: "icru@mahidol.ac.th",
        line2: "Tel. 0-2700-5000 ext. 4331-4334, 4336, 4342, 4330 and 4325",
        line3: "",
        line4: "",
        line5: "",
      },
      {
        name: "The Educational Affairs Section",
        mail: "songpole.san@mahidol.edu",
        line2: "Tel. 0-2700-5000 ext. 4311, 4314 and 4318",
        line3: "",
        line4: "sopa.nar@mahidol.ac.th",
        line5: "Mid-term and Final Examination",
      },
      {
        name: "The Office of Student Affairs",
        mail: "icsa@mahidol.ac.th",
        line2: "Tel. 0-2700-5000 ext. 1115, 1208 and 1210",
        line3: "Facebook: MUIC student affairs",
        line4: "",
        line5: "",
      },
      {
        name: "Library & Co-Working Space",
        mail: "iclibrary@mahidol.ac.th",
        line2: "Tel. 0-2700-5000 ext. 1415 and 1416",
        line3: "Facebook: MUIC Library & Co-Working Space",
        line4: "",
        line5: "",
      },
      {
        name: "The International Affairs Section",
        mail: "icia@mahidol.ac.th",
        line2: "Tel. 0-2700-5000 ext. 1708 and 1711",
        line3: "",
        line4: "",
        line5: "",
      },
      {
        name: "The Finance & Accounting Section",
        mail: "muicpayment@gmail.com",
        line2: "Tel. 0-2700-5000 ext. 1020, 1231 and 1326",
        line3: "",
        line4: "",
        line5: "",
      },
    ],
    dataContact2: [
      {
        name: "Business Administration Division",
        tel: "",
        mail: "sithapan.vir@mahidol.ac.th",
        mail1: "palita.sit@mahidol.ac.th",
        mail2: "woranan.api@mahidol.edu",
        line1:
          "Internship for BBA students, please contact thipsukhon.chu@mahidol.ac.th",
        line2: "Line: @273ygsch",
        line3: "Facebook: BBA MUIC",
        line4: "",
      },
      {
        name: "Fine and Applied Arts Division",
        tel: "Tel. 02-700-5000 ext. 4612 and 4611",
        mail: "sornpravate.kra@mahidol.edu",
        mail1: "icfaa@mahidol.ac.th",
        mail2: "",
        line1: "",
        line2: "",
        line3: "",
        line4: "",
      },
      {
        name: "Humanities and Language Division",
        tel: "Tel. 02-700-5000 ext.1213",
        mail: "chakriya.dua@mahidol.ac.th",
        mail1: "songrot.kit@mahidol.ac.th",
        mail2: "",
        line1: "",
        line2: "",
        line3: "",
        line4: "",
      },
      {
        name: "Science Division",
        tel: "Tel. 0-2700-5000 ext. 3516 and 3517",
        mail: "abhisit.suw@mahidol.edu",
        mail1: "panisara.aka@mahidol.edu",
        mail2: "",
        line1: "Line: @976wyacc",
        line2: "",
        line3: "",
        line4: "",
      },
      {
        name: "Social Science Division",
        tel: "Tel. 02-700-5000 ext. 1317 and 1713",
        mail: "benrisa.sur@mahidol.ac.th",
        mail1: "anisa.mek@mahidol.edu",
        mail2: "",
        line1: "",
        line2: "",
        line3: "",
        line4: "",
      },
      {
        name: "Tourism and Hospitality Management Division",
        tel: "Tel. 02-700-5000 ext. 4418 and 4419",
        mail: "veena.tha@mahidol.ac.th",
        mail1: "teerawan.nun@mahidol.ac.th",
        mail2: "",
        line1: "Line: @287kvjut",
        line2: "",
        line3: "",
        line4: "",
      },
    ],
  }),
};
</script>

<style scoped="scoped">
.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}
</style>